module.exports = __webpack_public_path__ + "static/media/ChannelSong.Malyalam.2456e0dc.jpg";